"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityStatusChip = exports.EmbeddableDataQualityStatusChip = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const react_dom_1 = require("react-dom");
const TelemetrySender_1 = require("../telemetry/TelemetrySender");
const DataQualityDetail_1 = require("./DataQualityDetail");
const DataQualityDetailPanel_1 = require("./DataQualityDetailPanel");
const DataQualityType_1 = require("./DataQualityType");
const DataQualityStatusChipId = 'data-quality-status-chip-id';
/**
 * @deprecated TFS-1478812
 */
function EmbeddableDataQualityStatusChip(props) {
    return (react_1.default.createElement(catalog_core_1.SiteUrlsProvider, { value: props.siteUrls },
        react_1.default.createElement(DataQualityStatusChip, Object.assign({}, props))));
}
exports.EmbeddableDataQualityStatusChip = EmbeddableDataQualityStatusChip;
/**
 * @deprecated TFS-1478812
 */
class DataQualityStatusChip extends react_1.default.Component {
    constructor(props) {
        var _a;
        super(props);
        this.setIsDialogOpen = (isDialogOpen) => {
            var _a, _b;
            if (!this.state.isDialogOpen && isDialogOpen) {
                const event = Object.assign(Object.assign({}, this.state.eventDetails), { content_type: (_b = (_a = this.props.details.find(t => t.onContentItem)) === null || _a === void 0 ? void 0 : _a.assetType) !== null && _b !== void 0 ? _b : 'unknown', elevated: this.props.details.some(d => d.isSevere), value: this.props.details.map(d => (0, DataQualityType_1.localizeDataQualityTypeName)(d.type)).join(',') });
                TelemetrySender_1.telemetrySender.sendEvent(event, {}, 'remove');
            }
            this.setState({ isDialogOpen });
        };
        this.ref = react_1.default.createRef();
        this.setRef = (button) => {
            if (button) {
                // eslint-disable-next-line react/no-find-dom-node
                this.setState({ iconOnlyButtonRef: (0, react_dom_1.findDOMNode)(button) });
            }
        };
        this.state = {
            isDialogOpen: false,
            eventDetails: {
                category: 'warning',
                source: `${(_a = props.source) !== null && _a !== void 0 ? _a : DataQualityStatusChipId}!deprecated`,
                type: 'label_opened',
            },
        };
    }
    render() {
        if (!this.props || this.props.details.length < 1) {
            return null;
        }
        const isSevere = this.props.details.some(d => d.isSevere);
        const text = dataQualityTooltipTitle(this.props);
        const baseProps = {
            text,
            warningKind: isSevere ? 'severe-warning' : 'standard-warning',
            testId: DataQualityStatusChipId,
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.props.iconOnly
                ? (react_1.default.createElement(DataQualityDetail_1.DataQualityTooltipButton, Object.assign({}, baseProps, { kind: 'interactive-icon', setRef: this.setRef, onClick: () => this.setIsDialogOpen(!this.state.isDialogOpen), tabIndex: this.props.iconOnlyTabIndex })))
                : (react_1.default.createElement(DataQualityDetail_1.DataQualityTooltipButton, Object.assign({}, baseProps, { kind: 'interactive-inline', ref: this.ref, onClick: () => this.setIsDialogOpen(!this.state.isDialogOpen) }))),
            this.state.isDialogOpen
                ? (react_1.default.createElement(DataQualityDetailPanel_1.DataQualityDetailPanel, Object.assign({}, this.props, { title: text, anchorEl: this.props.iconOnly
                        ? (this.state.iconOnlyButtonRef || undefined)
                        : this.ref.current, side: this.props.side || 'right', onCloseRequest: () => this.setState({ isDialogOpen: false }) })))
                : null));
    }
}
exports.DataQualityStatusChip = DataQualityStatusChip;
function dataQualityTooltipTitle(props) {
    if (!props || props.details.length < 1) {
        return '';
    }
    const count = props.details.length;
    if (count === 1) {
        return (0, DataQualityType_1.localizeDataQualityTypeName)(props.details[0].type);
    }
    return catalog_messages_1.Messages.DataQualityIconMessage({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: catalog_messages_1.Formatters.formatCount(count),
    });
}
//# sourceMappingURL=DataQualityStatusChip.js.map